export const getDefaultRc = (fileName: string) => import(`./${fileName}.json`);
